import _implicitStylesheets from "./tags.css";
import _implicitScopedStylesheets from "./tags.scoped.css?scoped=true";
import _axBar from "ax/bar";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="axwp-tags__title${0}"${2}><h3${3}>${"t2"}</h3></div>`;
const stc0 = {
  classMap: {
    "axwp-tags": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "axwp-tags__content": true
  },
  key: 3
};
const stc2 = {
  "axwp-single-tag": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, c: api_custom_element, h: api_element, i: api_iterator} = $api;
  return [api_element("div", stc0, [$cmp.hasTitle ? api_static_fragment($fragment1, 2, [api_static_part(2, null, api_dynamic_text($cmp.title))]) : null, api_element("div", stc1, api_iterator($cmp.tags, function (tag) {
    return api_element("div", {
      classMap: stc2,
      key: api_key(4, tag.key)
    }, [api_custom_element("ax-bar", _axBar, {
      props: {
        "text": tag.text,
        "href": tag.href,
        "variant": tag.variant,
        "icon": tag.icon
      },
      key: 5
    })]);
  }))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-27fjkfa07ib";
tmpl.legacyStylesheetToken = "undefined-_tags";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
